import * as React from 'react';
import { Grid} from '@mui/material';
import { Button, Media, Text } from '.';

interface Props {
  id?: string;
  name: string;
  label?: string;
  value: string;
  type?: 'image'|'audio'|'video';
  maxHeight?: number;
  circle?: boolean;
  encode?: boolean;
  readOnly?: boolean;
  disableMargin?: boolean;
  onLoad?: (data: any) => void;
  onChange?: (fieldName: string, value?: string) => void;
  error?: string;
}

export const InputFile: React.FunctionComponent<Props> = (props) => {
  const [type, setType] = React.useState('');
  const [isAudioVideo, setIsAudioVideo] = React.useState(false);
  const [iconOnly, setIconOnly] = React.useState(props.encode && !props.value);
  const [error, setError] = React.useState('');
  const sx = {...(!iconOnly && {minHeight: props.maxHeight || 150, maxHeight: props.maxHeight || 150, minWidth: props.maxHeight || 150, maxWidth: props.maxHeight || 150}) }
  const inputRef = React.useRef<any>();
  
  const getIconName = () => {
    switch (type || props.type){
      case 'image': return props.readOnly? 'hide_image' : 'add_photo_alternate';
      case 'audio': return props.value? 'audiotrack' : 'music_off';
      case 'video': return props.value? 'videocam' : 'videocam_off';
      default: return 'file_present'
    }
  }

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    var currentFiles: any;
    var currentType: any;
    var currentValue: any;
    
    if (e.target?.files?.length === 0) 
      return; //for cancel open file dialog

    if (e.target?.files?.length === 1) {
      currentFiles = e.target.files[0];
      currentType = currentFiles?.type?.split('/')[0];
      currentValue = currentType === 'image'? URL.createObjectURL(currentFiles) : currentFiles?.name;
      //currentValue='https://www.youtube.com/embed/I3p-PuZB8no?si=faLSijn4joMjdJuK'
      //src='https://freesound.org/data/previews/448/448573_9311684-lq.mp3'

      if (props.encode) {
        const reader = new FileReader();
        reader.readAsDataURL(currentFiles); 
        reader.onload = () => {
          currentFiles.path = reader.result; 
          currentFiles.filename = currentFiles?.name;
        }
      }
    }
    else inputRef.current.value = null;

    props.onChange?.(props.name, currentValue);
    props.onLoad?.(currentFiles);
    setIsAudioVideo(['audio', 'video'].includes(currentType));
    setIconOnly(props.encode && !currentValue);
    setError('');
  }

  return (
    <Grid id={props.id || props.name} mt={props.disableMargin? 0 : 2} mb={props.disableMargin? 0: 3}>      
      <Text label={props.label} size='small' color='text.secondary' marginBottom={1}/>
      <input ref={inputRef} type='file' accept={props.type? props.type+ '/*' : '*'} hidden onChange={onChange}/>
      
      <Grid position='relative' container>
        {props.value && !props.readOnly &&
        <Button type='contained' startIcon='delete_forever' color='red' size='extrasmall' disablePadding sx={{position: 'absolute', zIndex: 100, m: 0.5}} onClick={() => onChange(inputRef.current)}/>
        }
        <Button type='outlined' startIcon={iconOnly? 'attach_file' : ''} readOnly={props.readOnly} sx={{backgroundColor: 'whiteSmoke', borderRadius: props.circle ? 50 : 2, ...sx}} onClick={() => inputRef.current?.click()}>
          {!iconOnly &&
          <Grid container borderRadius='inherit'>
            <Media url={props.value} onLoad={v => setType(v)} onError={e => setError(e)} sx={{p: 0.2, borderRadius: 'inherit', ...(!isAudioVideo && sx)}}/>  
            {(!props.value || !type || isAudioVideo) &&
            <Text label={props.value} size='small' textAlign={props.value? 'left' : 'center'} icon={getIconName()} iconColor={props.readOnly? 'gray' : 'primary.main'} iconSize='extralarge' sx={{textTransform: 'lowercase', m: 1}} />
            }
          </Grid>
          }
        </Button>
      </Grid>  
      
      <Text label={props.error || error} size='small' color='red' />
    </Grid>    
  )
}


